import { observer } from "mobx-react";
import React, { useCallback, useState } from "react";
import { type PressableStateCallbackType } from "react-native";
import { Pressable } from "~/components/V2/Pressable";
import { BrandText } from "~/components/V2/Text/BrandText";
import type { AppointmentReasonInstance } from "~/mobx/entities/appointment-reasons/AppointmentReason";
import { styleConstantsV2 } from "~/style/styleConstantsV2";
import { AppointmentTypeModal } from "./AppointmentTypeModal";
import { Chip } from "./Chip";
import { View } from "./View";

export const AppointmentTypeCard = observer(function AppointmentTypeCard({
  appointmentType,
}: {
  appointmentType: AppointmentReasonInstance;
}) {
  const [isMoreInfoVisible, setIsMoreInfoVisible] = useState(false);
  const [isPressed, setIsPressed] = useState(false);

  const resolveBackgroundColor = useCallback(
    (state: PressableStateCallbackType) => {
      if (state.pressed) {
        return styleConstantsV2.colorPrimaryHoverLight;
      }
      if (state.hovered) {
        return styleConstantsV2.colorPrimaryHoverLight;
      }

      return styleConstantsV2.colorPrimaryBg;
    },
    [],
  );

  return (
    <>
      <Pressable
        alignItemsCenter
        onPressIn={() => {
          setIsPressed(true);
        }}
        onPressOut={() => {
          setIsPressed(false);
        }}
        onPress={() => {
          setIsMoreInfoVisible(!isMoreInfoVisible);
        }}
        flexDirectionRow
        colorPrimaryBg
        padding16
        style={(state) => {
          return {
            backgroundColor: resolveBackgroundColor(state),
            borderRadius: 4,
          };
        }}
      >
        <View flex justifyContentCenter>
          <BrandText colorBlack weightBold sizeH4>
            {appointmentType.name}
          </BrandText>
        </View>

        <Chip
          title={intl.formatMessage({
            id: "jnMZTV",
            defaultMessage: "More info",
            description: "More info text on chip on appointment type card",
          })}
          backgroundColor={
            isPressed
              ? styleConstantsV2.colorGrey20
              : styleConstantsV2.colorWhite
          }
          size="small"
          iconPosition="right"
          iconName="chevron-right"
          iconSize={24}
          iconColor={styleConstantsV2.colorBlack}
        />
      </Pressable>
      <AppointmentTypeModal
        isVisible={isMoreInfoVisible}
        appointmentType={appointmentType}
        setIsMoreInfoVisible={setIsMoreInfoVisible}
      />
    </>
  );
});
